'use client';

import React, { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Cloud01: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M6.5 19C4.01472 19 2 16.9853 2 14.5C2 12.1564 3.79151 10.2313 6.07974 10.0194C6.54781 7.17213 9.02024 5 12 5C14.9798 5 17.4522 7.17213 17.9203 10.0194C20.2085 10.2313 22 12.1564 22 14.5C22 16.9853 19.9853 19 17.5 19C13.1102 19 10.3433 19 6.5 19Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Cloud02: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M6 19C3.79086 19 2 17.2091 2 15C2 13.1358 3.27532 11.5694 5.00111 11.1257C5.00037 11.0839 5 11.042 5 11C5 7.13401 8.13401 4 12 4C15.6099 4 18.5815 6.73249 18.9594 10.2419C20.7284 10.8481 22 12.5255 22 14.5C22 16.9853 19.9853 19 17.5 19C13.7609 19 10.1876 19 6 19Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Cloud03: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M9.5 19C5.35786 19 2 15.6421 2 11.5C2 7.35786 5.35786 4 9.5 4C12.3827 4 14.8855 5.62634 16.141 8.01153C16.2597 8.00388 16.3794 8 16.5 8C19.5376 8 22 10.4624 22 13.5C22 16.5376 19.5376 19 16.5 19C13.9485 19 12.1224 19 9.5 19Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudLightning: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M19 15.7439C20.7478 15.1262 22 13.4593 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.4593 3.25221 15.1262 5 15.7439M13 10L9 16H15L11 22"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudMoon: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16.5 13C19.0768 13 21.2397 11.228 21.8366 8.83604C21.4087 8.94287 20.961 8.99958 20.5 8.99958C17.4624 8.99958 15 6.53715 15 3.49958C15 3.03881 15.0567 2.59128 15.1634 2.16357C12.7717 2.76068 11 4.92345 11 7.50003C11 8.41275 11.2223 9.27355 11.6158 10.0312M5 7V3M3 5H7M6 22C3.79086 22 2 20.2091 2 18C2 16.0221 3.43551 14.3796 5.32148 14.0573C6.12876 11.697 8.3662 10 11 10C13.2882 10 15.2772 11.2809 16.2892 13.1648C16.6744 13.0574 17.0805 13 17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22C13.6667 22 9.83333 22 6 22Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudOff: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M21.7003 16.1181C21.8939 15.616 22 15.0704 22 14.5C22 12.1564 20.2085 10.2313 17.9203 10.0194C17.4522 7.17213 14.9798 5 12 5C11.5534 5 11.1183 5.04879 10.6995 5.14132M7.28746 7.28585C6.67317 8.06419 6.24759 8.99838 6.07974 10.0194C3.79151 10.2313 2 12.1564 2 14.5C2 16.9853 4.01472 19 6.5 19H17.5C17.9561 19 18.3963 18.9322 18.8112 18.806M3 3L21 21"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M8 18V20M8 12V14M16 18V20M16 12V14M12 20V22M12 14V16"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16 12V20M8 12V20M12 14V22M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M12.25 15L9.44995 22M17.05 13L14.25 20M9.05 13L6.25 20"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining04: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16 18.5V21M8 18.5V21M12 19.5V22M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining05: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16 18.5L15 21M8 18.5L7 21M12 18.5L11 21M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudRaining06: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M13 21H6M19 18H10M7 18H5M18 21H16M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudSnowing01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M8 15H8.01M8 19H8.01M12 17H12.01M12 21H12.01M16 15H16.01M16 19H16.01"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudSnowing02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M8 18H8.01M8 21H8.01M12 18.5H12.01M12 21.5H12.01M16 18H16.01M16 21H16.01M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudSun01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M19.368 12.4048C20.935 11.5606 22 9.9047 22 8C22 5.23858 19.7614 3 17 3C14.2386 3 12 5.23858 12 8M12 8C9.86227 8 8.0094 9.2196 7.09922 11.001C7.06622 11.0003 7.03315 11 7 11C4.23858 11 2 13.2386 2 16C2 18.7614 4.23858 21 7 21C11.2352 21 13.7434 21 17.5 21C19.9853 21 22 18.9853 22 16.5C22 14.0147 19.9853 12 17.5 12C17.4311 12 17.3625 12.0016 17.2943 12.0046C16.6429 9.69375 14.5192 8 12 8Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudSun02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M10.5 1.5V3.1M3.6 10H2M5.4512 4.95137L4.31982 3.82M15.5498 4.95137L16.6812 3.82M19 10H17.4M6.50007 10.0001C6.50007 7.79093 8.29093 6.00007 10.5001 6.00007C12.0061 6.00007 13.3177 6.83235 14.0001 8.06206M6 22C3.79086 22 2 20.2091 2 18C2 15.7909 3.79086 14 6 14C6.46419 14 6.90991 14.0791 7.32442 14.2245C8.04061 12.3396 9.86387 11 12 11C14.1361 11 15.9594 12.3396 16.6756 14.2245C17.0901 14.0791 17.5358 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C13.3597 22 9.87921 22 6 22Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const CloudSun03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M3.15003 11C3.05165 10.5153 3 10.0137 3 9.5C3 5.35786 6.35786 2 10.5 2C14.3031 2 17.445 4.83064 17.9339 8.5M6 22C3.79086 22 2 20.2091 2 18C2 15.7909 3.79086 14 6 14C6.11333 14 6.22556 14.0047 6.3365 14.014C7.15622 11.6763 9.38235 10 12 10C14.2248 10 16.1668 11.2109 17.2029 13.0097C17.3011 13.0033 17.4002 13 17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22C13.7633 22 10.0546 22 6 22Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Droplets01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16C10 11.6863 16 2 16 2C16 2 22 11.6863 22 16Z"
                {...pathProps}
            />
            <IconPath
                d="M8 9C8 10.6569 6.65685 12 5 12C3.34315 12 2 10.6569 2 9C2 6.84315 5 2 5 2C5 2 8 6.84315 8 9Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Droplets02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 21.5C13.8565 21.5 15.637 20.7625 16.9497 19.4497C18.2625 18.137 19 16.3565 19 14.5C19 12.5 18 10.6 16 9C14 7.4 12.5 5 12 2.5C11.5 5 10 7.4 8 9C6 10.6 5 12.5 5 14.5C5 16.3565 5.7375 18.137 7.05025 19.4497C8.36301 20.7625 10.1435 21.5 12 21.5Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Droplets03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12.56 6.08C13.2478 4.98112 13.7353 3.76904 14 2.5C14.5 5 16 7.4 18 9C20 10.6 21 12.5 21 14.5C21.0057 15.8823 20.6009 17.2352 19.8368 18.3871C19.0727 19.539 17.9838 20.4382 16.7081 20.9705C15.4324 21.5028 14.0274 21.6444 12.6712 21.3773C11.3149 21.1101 10.0685 20.4463 9.09 19.47M7 15.78C9.2 15.78 11 13.95 11 11.73C11 10.57 10.43 9.47 9.29 8.54C8.15 7.61 7.29 6.23 7 4.78C6.71 6.23 5.86 7.62 4.71 8.54C3.56 9.46 3 10.58 3 11.73C3 13.95 4.8 15.78 7 15.78Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Hurricane01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16.5 20.5002C15.2465 20.814 13.6884 21 12 21C10.3116 21 8.75349 20.814 7.5 20.5002M18 16.4305C16.5341 16.9842 14.3894 17.3333 12 17.3333C9.61061 17.3333 7.46589 16.9842 6 16.4305M4.5 11.6679C5.93143 12.5598 8.75311 13.1667 12 13.1667C15.2469 13.1667 18.0686 12.5598 19.5 11.6679M21 6C21 7.65685 16.9706 9 12 9C7.02944 9 3 7.65685 3 6C3 4.34315 7.02944 3 12 3C16.9706 3 21 4.34315 21 6Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Hurricane02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12M18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12M18 12C18 16.4183 14.4183 20 10 20C5.58172 20 2 16.4183 2 12M6 12C6 7.58172 9.58172 4 14 4C18.4183 4 22 7.58172 22 12M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Hurricane03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M21 4H3M20 8L6 8M18 12L9 12M15 16L8 16M17 20H12"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Lightning01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Lightning02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M14.2495 2H8.49395C8.31447 2 8.22473 2 8.14551 2.02733C8.07544 2.05149 8.01163 2.09093 7.95868 2.14279C7.89881 2.20143 7.85868 2.2817 7.77841 2.44223L3.57841 10.8422C3.38673 11.2256 3.29089 11.4173 3.31391 11.5731C3.33401 11.7091 3.40927 11.8309 3.52197 11.9097C3.65104 12 3.86534 12 4.29395 12H10.4995L7.49953 22L19.6926 9.35531C20.104 8.9287 20.3097 8.7154 20.3217 8.53288C20.3321 8.37446 20.2667 8.22049 20.1454 8.11803C20.0057 8 19.7094 8 19.1167 8H11.9995L14.2495 2Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Moon01: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M22 15.8442C20.6866 16.4382 19.2286 16.7688 17.6935 16.7688C11.9153 16.7688 7.23116 12.0847 7.23116 6.30654C7.23116 4.77135 7.5618 3.3134 8.15577 2C4.52576 3.64163 2 7.2947 2 11.5377C2 17.3159 6.68414 22 12.4623 22C16.7053 22 20.3584 19.4742 22 15.8442Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Moon02: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M21.9548 12.9564C20.5779 15.3717 17.9791 17.0001 15 17.0001C10.5817 17.0001 7 13.4184 7 9.00008C7 6.02072 8.62867 3.42175 11.0443 2.04492C5.96975 2.52607 2 6.79936 2 11.9998C2 17.5227 6.47715 21.9998 12 21.9998C17.2002 21.9998 21.4733 18.0305 21.9548 12.9564Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const MoonEclipse: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M20.0017 6.00022C22.6667 9.54505 22.6661 14.4578 20 18.0021M12 22C13.5711 22 15.0575 21.6377 16.3803 20.9921C16.2542 20.9974 16.1274 21 16 21C11.0294 21 7 16.9706 7 12C7 7.02944 11.0294 3 16 3C16.1274 3 16.2542 3.00265 16.3803 3.00789C15.0575 2.36229 13.5711 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const MoonStar: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M18 2L18.6178 3.23558C18.8833 3.76656 19.016 4.03205 19.1934 4.26211C19.3507 4.46626 19.5337 4.64927 19.7379 4.80664C19.9679 4.98397 20.2334 5.11672 20.7644 5.38221L22 6L20.7644 6.61779C20.2334 6.88328 19.9679 7.01603 19.7379 7.19336C19.5337 7.35073 19.3507 7.53374 19.1934 7.73789C19.016 7.96795 18.8833 8.23344 18.6178 8.76442L18 10L17.3822 8.76442C17.1167 8.23344 16.984 7.96795 16.8066 7.73789C16.6493 7.53374 16.4663 7.35073 16.2621 7.19336C16.0321 7.01603 15.7666 6.88328 15.2356 6.61779L14 6L15.2356 5.38221C15.7666 5.11672 16.0321 4.98397 16.2621 4.80664C16.4663 4.64927 16.6493 4.46626 16.8066 4.26211C16.984 4.03205 17.1167 3.76656 17.3822 3.23558L18 2Z"
                {...pathProps}
            />
            <IconPath
                d="M21 13.3893C19.689 15.689 17.2145 17.2395 14.3779 17.2395C10.1711 17.2395 6.76075 13.8292 6.76075 9.62233C6.76075 6.78554 8.31149 4.31094 10.6115 3C5.77979 3.45812 2 7.52692 2 12.4785C2 17.7371 6.26292 22 11.5215 22C16.4729 22 20.5415 18.2206 21 13.3893Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const SnowFlake01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M18.0622 8.5L5.9378 15.5M18.0622 8.5L19.1602 4.40192M18.0622 8.5L22.1602 9.59808M5.9378 15.5L1.83972 14.4019M5.9378 15.5L4.83972 19.5981M18.0621 15.4999L5.93771 8.49986M18.0621 15.4999L22.1602 14.4018M18.0621 15.4999L19.1602 19.598M5.93771 8.49986L4.83986 4.40203M5.93771 8.49986L1.83986 9.59819M12 5L12 19M12 5L8.99998 2M12 5L15 2M12 19L8.99998 22M12 19L15 22"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const SnowFlake02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 8V16M12 8V2M12 8L7 3M12 8L17 3M12 16V22M12 16L7 21M12 16L17 21M16 12H8M16 12H22M16 12L21 7M16 12L21 17M8 12H2M8 12L3 7M8 12L3 17"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const StarW01: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
                {...pathProps}
            />
            <IconPath
                d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const StarW02: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const StarW03: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M18.5 8V3M5.5 21V16M16 5.5H21M3 18.5H8M6.5 2L5.71554 3.56892C5.45005 4.09989 5.31731 4.36538 5.13997 4.59545C4.98261 4.79959 4.79959 4.98261 4.59545 5.13997C4.36538 5.31731 4.0999 5.45005 3.56892 5.71554L2 6.5L3.56892 7.28446C4.0999 7.54995 4.36538 7.68269 4.59545 7.86003C4.79959 8.01739 4.98261 8.20041 5.13997 8.40455C5.31731 8.63462 5.45005 8.9001 5.71554 9.43108L6.5 11L7.28446 9.43108C7.54995 8.9001 7.68269 8.63462 7.86003 8.40455C8.01739 8.20041 8.20041 8.01739 8.40455 7.86003C8.63462 7.68269 8.9001 7.54995 9.43108 7.28446L11 6.5L9.43108 5.71554C8.9001 5.45005 8.63462 5.31731 8.40455 5.13997C8.20041 4.98261 8.01739 4.79959 7.86003 4.59545C7.68269 4.36538 7.54995 4.0999 7.28446 3.56892L6.5 2ZM17 12L16.0489 13.9022C15.7834 14.4332 15.6506 14.6987 15.4733 14.9288C15.3159 15.1329 15.1329 15.3159 14.9288 15.4733C14.6987 15.6506 14.4332 15.7834 13.9023 16.0489L12 17L13.9023 17.9511C14.4332 18.2166 14.6987 18.3494 14.9288 18.5267C15.1329 18.6841 15.3159 18.8671 15.4733 19.0712C15.6506 19.3013 15.7834 19.5668 16.0489 20.0977L17 22L17.9511 20.0978C18.2166 19.5668 18.3494 19.3013 18.5267 19.0712C18.6841 18.8671 18.8671 18.6841 19.0712 18.5267C19.3013 18.3494 19.5668 18.2166 20.0977 17.9511L22 17L20.0977 16.0489C19.5668 15.7834 19.3013 15.6506 19.0712 15.4733C18.8671 15.3159 18.6841 15.1329 18.5267 14.9288C18.3494 14.6987 18.2166 14.4332 17.9511 13.9023L17 12Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const SunSetting01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 3V5M5.31412 7.31412L3.8999 5.8999M18.6858 7.31412L20.1 5.8999M6 15C6 11.6863 8.68629 9 12 9C15.3137 9 18 11.6863 18 15M22 15H2M19 19H5"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const SunSetting02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M22 16.5H2M20 20H4M12 3V5M4 13H2M6.31412 7.31412L4.8999 5.8999M17.6855 7.31412L19.0998 5.8999M22 13H20M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const SunSetting03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M6.06006 20.9125C7.27006 21.4625 8.81006 21.4625 10.0201 20.9125C11.2301 20.3625 12.7701 20.3625 13.9801 20.9125C15.1901 21.4625 16.7301 21.4625 17.9401 20.9125M12 3V5M4 13H2M6.31412 7.31412L4.8999 5.8999M17.6855 7.31412L19.0998 5.8999M22 13H20M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13M2.1001 17.4125C3.3101 16.8625 4.8501 16.8625 6.0601 17.4125C7.2701 17.9625 8.8101 17.9625 10.0201 17.4125C11.2301 16.8625 12.7701 16.8625 13.9801 17.4125C15.1901 17.9625 16.7301 17.9625 17.9401 17.4125C19.1501 16.8625 20.6901 16.8625 21.9001 17.4125"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Sun: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 2V4M12 20V22M4 12H2M6.31412 6.31412L4.8999 4.8999M17.6859 6.31412L19.1001 4.8999M6.31412 17.69L4.8999 19.1042M17.6859 17.69L19.1001 19.1042M22 12H20M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Sunrise: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 6L12 2M12 2L8 6M12 2V9"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Sunset: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 5L12 9M12 9L8 5M12 9V2"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Thermometer01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5V13.7578C8.29401 14.565 7.5 15.9398 7.5 17.5C7.5 19.9853 9.51472 22 12 22C14.4853 22 16.5 19.9853 16.5 17.5C16.5 15.9398 15.706 14.565 14.5 13.7578V4.5Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Thermometer02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5V13.7578C8.29401 14.565 7.5 15.9398 7.5 17.5C7.5 19.9853 9.51472 22 12 22C14.4853 22 16.5 19.9853 16.5 17.5C16.5 15.9398 15.706 14.565 14.5 13.7578V4.5Z"
                {...pathProps}
            />
            <IconPath
                d="M12 18.5C12.5523 18.5 13 18.0523 13 17.5C13 16.9477 12.5523 16.5 12 16.5C11.4477 16.5 11 16.9477 11 17.5C11 18.0523 11.4477 18.5 12 18.5Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Thermometer03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M21 3L15 3M21 7L15 7M21 11L15 11M5.5 13.7578V4.5C5.5 3.11929 6.61929 2 8 2C9.38071 2 10.5 3.11929 10.5 4.5V13.7578C11.706 14.565 12.5 15.9398 12.5 17.5C12.5 19.9853 10.4853 22 8 22C5.51472 22 3.5 19.9853 3.5 17.5C3.5 15.9398 4.29401 14.565 5.5 13.7578ZM9 17.5C9 18.0523 8.55228 18.5 8 18.5C7.44772 18.5 7 18.0523 7 17.5C7 16.9477 7.44772 16.5 8 16.5C8.55228 16.5 9 16.9477 9 17.5Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const ThermometerCold: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M2 12H12M9 4V20M3 9L6 12L3 15M12 6L9 9L6 6M6 18L9 15L10.5 16.5M20 14.5351V4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4V14.5351C14.8044 15.2267 14 16.5194 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18C22 16.5194 21.1956 15.2267 20 14.5351Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const ThermometerWarm: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 9C11.1077 8.98562 10.2363 9.27003 9.52424 9.808C8.81222 10.346 8.30055 11.1066 8.07061 11.9688C7.84068 12.8311 7.90568 13.7455 8.25529 14.5665C8.6049 15.3876 9.21904 16.0682 10 16.5M12 3V5M6.6 18.4L5.2 19.8M4 13H2M6.6 7.6L5.2 6.2M20 14.5351V4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4V14.5351C14.8044 15.2267 14 16.5194 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18C22 16.5194 21.1956 15.2267 20 14.5351Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Umbrella01: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M17 19.4C17 20.8359 15.8807 22 14.5 22C13.1193 22 12 20.8359 12 19.4V12M2.12627 10.4063C2.88948 5.64091 7.01953 2 12 2C16.9804 2 21.1104 5.64091 21.8737 10.4063C21.9482 10.8714 21.9854 11.1039 21.8919 11.3523C21.8175 11.55 21.6353 11.7636 21.4519 11.8684C21.2214 12 20.9476 12 20.4 12H3.59997C3.05232 12 2.7785 12 2.54801 11.8684C2.36463 11.7636 2.18246 11.55 2.10805 11.3523C2.01453 11.1039 2.05178 10.8714 2.12627 10.4063Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Umbrella02: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M7 19.4C7 20.8359 8.11929 22 9.5 22C10.8807 22 12 20.8359 12 19.4V11M12 11C10.3898 11 8 12 8 12C8 12 6.61017 11 5 11C3.38983 11 2 12 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12 20.6102 11 19 11C17.3898 11 16 12 16 12C16 12 13.6102 11 12 11Z"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Umbrella03: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M6.25 21.9595L12 12.0002M17 3.33995C12.6868 0.849735 7.28964 1.93783 4.246 5.68314C3.94893 6.0487 3.80039 6.23148 3.75718 6.49336C3.7228 6.70172 3.77373 6.97785 3.88018 7.16024C4.01398 7.38947 4.25111 7.52638 4.72539 7.8002L19.2746 16.2002C19.7489 16.474 19.986 16.6109 20.2514 16.6122C20.4626 16.6132 20.7272 16.5192 20.8905 16.3853C21.0957 16.2169 21.1797 15.9969 21.3477 15.5568C23.0695 11.0483 21.3132 5.83017 17 3.33995ZM17 3.33995C15.0868 2.23538 11.2973 5.21728 8.5359 10.0002M17 3.33995C18.9132 4.44452 18.2255 9.21728 15.4641 14.0002M22 22.0002H2"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Waves: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M2 6C2.6 6.5 3.2 7 4.5 7C7 7 7 5 9.5 5C10.8 5 11.4 5.5 12 6C12.6 6.5 13.2 7 14.5 7C17 7 17 5 19.5 5C20.8 5 21.4 5.5 22 6M2 18C2.6 18.5 3.2 19 4.5 19C7 19 7 17 9.5 17C10.8 17 11.4 17.5 12 18C12.6 18.5 13.2 19 14.5 19C17 19 17 17 19.5 17C20.8 17 21.4 17.5 22 18M2 12C2.6 12.5 3.2 13 4.5 13C7 13 7 11 9.5 11C10.8 11 11.4 11.5 12 12C12.6 12.5 13.2 13 14.5 13C17 13 17 11 19.5 11C20.8 11 21.4 11.5 22 12"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Wind01: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M21 18C21 18 19.8096 17.5305 19 17.3021C13.8797 15.8574 10.1203 20.1426 5 18.6979C4.19041 18.4695 3 18 3 18M21 12C21 12 19.8096 11.5305 19 11.3021C13.8797 9.85739 10.1203 14.1426 5 12.6979C4.19041 12.4695 3 12 3 12M21 6C21 6 19.8096 5.53048 19 5.30206C13.8797 3.85739 10.1203 8.14261 5 6.69794C4.19041 6.46952 3 6 3 6"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Wind02: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M9.50929 4.66667C9.8755 4.2575 10.4077 4 11 4C12.1046 4 13 4.89543 13 6C13 7.10457 12.1046 8 11 8H2.00002M12.5093 19.3333C12.8755 19.7425 13.4077 20 14 20C15.1046 20 16 19.1046 16 18C16 16.8954 15.1046 16 14 16H2.00002M16.7639 7C17.3132 6.38625 18.1115 6 19 6C20.6569 6 22 7.34315 22 9C22 10.6569 20.6569 12 19 12H2"
                {...pathProps}
            />
        </IconSVG>
    );
};

export const Wind03: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M16.7639 6.5C17.3132 5.88625 18.1115 5.5 19 5.5C20.6569 5.5 22 6.84315 22 8.5C22 10.1569 20.6569 11.5 19 11.5H13M6.7639 4C7.31322 3.38625 8.1115 3 9 3C10.6569 3 12 4.34315 12 6C12 7.65685 10.6569 9 9 9H2M10.7639 20C11.3132 20.6137 12.1115 21 13 21C14.6569 21 16 19.6569 16 18C16 16.3431 14.6569 15 13 15H2"
                {...pathProps}
            />
        </IconSVG>
    );
};
